import { FeedBackLevel } from '@chipinside/formbuilder'
import { Translate } from '@chipinside/translate'
import { IconButton, Stack, Tooltip } from '@mui/material'
import { isEmpty } from 'lodash'
import { ReactNode } from 'react'

import { Dialog } from '#/components/Dialog'
import FormatCell from '#/components/FormatCell'
import { Icon } from '#/components/Icon'
import { Image } from '#/components/Image'

type Value = {
  url: string
  audit: { created_by: string; created_at: string; updated_by: string; updated_at: string }
  title: string
}

type Action = {
  title: string
  enabled: boolean
  onClick: () => void
  level?: FeedBackLevel
  icon: ReactNode
}

type Props = {
  value: Value
  actions?: Action[]
}

export const TypeImage = ({ actions = [], value }: Props) => {
  if (isEmpty(value)) return '-'
  const { audit, title, url } = value

  const viewPhotoText = Translate({
    messageKey: 'view_item',
    params: { item: Translate({ lower: true, messageKey: 'photo' }) },
  })

  const handleClick = () => {
    Dialog.open({
      content: (
        <Stack sx={{ alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
          <Image url={url} />
        </Stack>
      ),
      header: {
        subtitle: title,
        suffix: (
          <>
            {actions
              ?.filter(action => action.enabled)
              .map(action => (
                <Tooltip key={action.title} title={action.title}>
                  <IconButton color={action.level} onClick={action.onClick}>
                    {action.icon}
                  </IconButton>
                </Tooltip>
              ))}
            <FormatCell type="infos" value={audit} />
          </>
        ),
        title: viewPhotoText,
      },
      maxWidth: 'md',
    })
  }

  return (
    <Tooltip title={viewPhotoText}>
      <IconButton onClick={handleClick} color="primary">
        <Icon name="camera" />
      </IconButton>
    </Tooltip>
  )
}
